import { cx } from '@linaria/core';
import { useRef } from 'react';
import { resets } from '@ui/css';
import { useHighlightSelectedTab } from './hook.highlight-selected-tab.js';
import { wrapper, initialRenderModifier, selectedTabHighlight, tab } from './toggle-group.style.js';
import { handleTablistKeydownEvent } from './util.key-down.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ToggleGroup(props) {
  const ref = useRef(null);
  const selectedTabRef = useRef(null);

  // initialized is used to prevent animation from triggering on initial render
  const initialized = useHighlightSelectedTab(ref, {
    selectedTabRef: selectedTabRef,
    selectedTabId: props.selectedTabId
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    jsxs("div", {
      ref: ref,
      role: "tablist",
      className: cx(resets.rootCls, wrapper, props.className, !initialized && initialRenderModifier),
      "aria-label": props.label,
      onKeyDown: handleTablistKeydownEvent,
      children: [/*#__PURE__*/jsx("div", {
        className: selectedTabHighlight
      }), props.tabs?.map(it =>
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      jsx("button", {
        ref: it.id === props.selectedTabId ? selectedTabRef : undefined,
        id: `${props.baseId}-tab-${it.id}`,
        className: tab,
        "aria-selected": it.id === props.selectedTabId ? "true" : "false",
        "aria-controls": `${props.baseId}-panel-${it.id}`,
        tabIndex: it.id === props.selectedTabId ? 0 : -1,
        onClick: () => props.onTabClick(it.id),
        children: /*#__PURE__*/jsx("span", {
          children: it.title
        })
      }, it.id))]
    })
  );
}

export { ToggleGroup };
//# sourceMappingURL=toggle-group.js.map
